const radii = {
  none: '0',
  sm: '0.125rem',
  base: '0.200rem',
  md: '0.375rem',
  lg: '0.5rem',
  xl: '0.75rem',
  '2xl': '1rem',
  '3xl': '1.5rem',
  full: '9999px',
};

const breakpoints = {
  sm: '426px', // =425px
  md: '1025px', // =1024px
  lg: '1441px', // =1440px
  xl: '2561px', // =2560px
  '2xl': '2561px', // =2560px
};

const basic = {
  transparent: 'transparent',
  black: '#000000',
  white: '#FFFFFF',
};

const red = {
  50: '#FCE9EB',
  100: '#F7C0C6',
  200: '#F198A2',
  300: '#EC6F7D',
  400: '#E64759',
  500: '#E11E34',
  600: '#B4182A',
  700: '#87121F',
  800: '#5A0C15',
  900: '#2D060A',
};

const blue = {
  50: '#ECE9FB',
  100: '#CBC2F4',
  200: '#AA9BEE',
  300: '#8874E7',
  400: '#674DE0',
  500: '#1C0F57',
  600: '#371EAE',
  700: '#2A1782',
  800: '#1C0F57',
  900: '#0E082B',
};

const green = {
  50: '#F0F8EC',
  100: '#D5ECCB',
  200: '#BBDFA9',
  300: '#A0D388',
  400: '#85C666',
  500: '#6BBA45',
  600: '#559537',
  700: '#407029',
  800: '#2B4A1C',
  900: '#15250E',
};

const fontSizes = {
  '2xs': '9px',
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '30px',
  '4xl': '36px',
  '5xl': '48px',
};

const fontWeights = {
  thin: 100,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

const fonts = {
  body: "'Poppins', sans-serif",
  heading: "'Poppins', sans-serif",
  mono: "'Poppins', sans-serif",
};

const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
};

const lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: '2',
  3: '.75rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
};

const sizes = {
  max: 'max-content',
  min: 'min-content',
  full: '100%',
  '3xs': '14rem',
  '2xs': '16rem',
  xs: '5px',
  sm: '9px',
  md: '16px',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem',
  '3xl': '48rem',
  '4xl': '56rem',
  '5xl': '64rem',
  '6xl': '72rem',
  '7xl': '80rem',
  '8xl': '90rem',
  container: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};

const space = {
  '2xs': '2px',
  xs: '5px',
  sm: '9px',
  md: '16px',
  lg: '32px',
  xl: '45px',
  '2xl': '52px',
};

export const foundations = {
  global: () => ({
    body: {
      fontFamily: "'Poppins', sans-serif",
    },
  }),
  colors: { basic, red, blue, green },
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  breakpoints,
  sizes,
  radii,
  space,
};
